import script from "./DesignView.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignView.vue?vue&type=script&setup=true&lang=js"

import "./DesignView.vue?vue&type=style&index=0&id=35c99ea1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35c99ea1"]])

export default __exports__